<template>
  <AuthForm>
    <template v-slot:header>
      <h2 v-translate>Publication accessible uniquement avec login autorisé</h2>
    </template>

    <div class="col-md-12">
      <p class="trusted">
        <translate :translate-params="{ email: email }"
          >Merci d'avoir créé un compte sur Navigart. Un email contenant un lien vous a été envoyé à l'adresse
          %{email}.</translate
        >
        <br />
        <translate>Merci de cliquer sur ce lien pour confirmer la création de votre compte.</translate>
        <br />
        <translate>
          Attention : il est possible que l'email arrive dans votre boîte email dans quelques dizaines de minutes ou soit dirigé automatiquement dans votre dossier de courrier indésirable (pensez à vérifier vos spams).
        </translate>
      </p>
    </div>
  </AuthForm>
</template>

<script>
import { mapState } from 'vuex';
import AuthForm from './AuthForm.vue';

export default {
  name: 'Unconfirmed',
  components: {
    AuthForm,
  },
  computed: {
    ...mapState('route', ['params']),
    email() {
      return this.params['email'];
    },
  },
};
</script>
